import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./header.css";
import DarkMode from "../../components/darkMode/darkMode.js";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';

const Header = () => {
  const [currentTheme, setCurrentTheme] = useState("light");
  const navigate = useNavigate();
  const location = useLocation();
  const headerLinksRef = useRef(null);

  const handleThemeChange = (newTheme) => {
    setCurrentTheme(newTheme);
  };

  const [menuOpen, setMenuOpen] = useState(false);
  const token = localStorage.getItem("token");
  const isAuthenticated = !!token;

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/"); // Redirige l'utilisateur vers la page d'accueil
  };

  const handleClickOutside = (event) => {
    if (headerLinksRef.current && !headerLinksRef.current.contains(event.target)) {
      setMenuOpen(false);
    }
  };

  useEffect(() => {
    if (menuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuOpen]);

  return (
    <header className="header">
      <div className="logo">
        <Link to="/">Nadia's Portfolio</Link>
      </div>
      <div className={`header-links ${menuOpen ? "open" : ""}`} ref={headerLinksRef}>
        {location.pathname !== "/" && <Link to="/"><FontAwesomeIcon icon={faHome} /></Link>}
        <Link to="/projets">Projets</Link>
        {location.pathname === "/" && <a href="#contact">Contact</a>}
        <Link to="/cv">CV</Link>

        {isAuthenticated ? (
          <div className="login" onClick={handleLogout}>
            Se déconnecter
          </div>
        ) : (
          <Link to="/connexion">Se connecter</Link>
        )}

        <div>
          <DarkMode
            currentTheme={currentTheme}
            onThemeChange={handleThemeChange}
          />
        </div>
      </div>
      <div className="menu-hamburger" onClick={toggleMenu}>
        <div className={`hamburger ${menuOpen ? "open" : ""}`}>
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
        </div>
      </div>
    </header>
  );
};

export default Header;
